<template>
  <div v-if="isActive && shouldShow" :id="id" ref="floatingEl" :style="floatingStyles">
    <div :class="['trv-tooltip', placementClass, themeClass]">
      <div v-if="arrow" ref="arrowEl" class="trv-tooltip__arrow" :style="arrowStyles" />
      <div class="trv-tooltip__content">
        <div class="tooltip">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { CSSProperties } from 'vue'

interface Props {
  isActive: boolean
  shouldShow: boolean
  id: string
  floatingStyles: CSSProperties
  placementClass?: string
  themeClass?: string
  arrow: boolean
  arrowStyles: CSSProperties
}

defineProps<Props>()

const floatingEl = ref<HTMLElement | null>(null)
const arrowEl = ref<HTMLElement | null>(null)

// Expose refs so parent can access them
defineExpose({
  floatingEl,
  arrowEl
})
</script>
